import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TextField,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import Loading from "../../Loading";
import FileUpload from "../Components/FileUpload";
import CreateAmountsOwed from "./AmountsOwedModal/Create";
import DeleteAmountsOwed from "./AmountsOwedModal/Delete";
import EditAmountsOwed from "./AmountsOwedModal/Edit";
import CreateContingentLiabilities from "./ContingentLiabilitiesModal/Create";
import DeleteContingentLiabilities from "./ContingentLiabilitiesModal/Delete";
import EditContingentLiabilities from "./ContingentLiabilitiesModal/Edit";
import CreateCreditCard from "./CreditCardModal/Create";
import DeleteCreditCard from "./CreditCardModal/Delete";
import EditCreditCard from "./CreditCardModal/Edit";
import CreateFederalLiability from "./FederalLiabilitiesModal/Create";
import DeleteFederalLiability from "./FederalLiabilitiesModal/Delete";
import EditFederalLiability from "./FederalLiabilitiesModal/Edit";
import CreateOtherLiabilities from "./OtherLiabilitiesModal/Create";
import DeleteOtherLiabilities from "./OtherLiabilitiesModal/Delete";
import EditOtherLiabilities from "./OtherLiabilitiesModal/Edit";
import ShowNoteComponent from "./ShowNoteComponent";
import { debounce } from "lodash";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import GreenCheckBadge from "../Components/Badge";

const useRowStyles = makeStyles({
    root: {
      "& > *": {
        borderBottom: "unset",
      },
    },
  });
  
function FederalLiabitlitesRow(props) {
    const { row, client_case_id, setLiabilities } = props;
    const [open, setOpen] = useState(false);
    const classes = useRowStyles();
    const mobile = window.matchMedia("(max-width: 768px)");
    const [isMobile, setIsMobile] = useState(mobile.matches);
  
    useEffect(() => {
      const windowHandler = () => {
        setIsMobile(mobile.matches);
        if (!isMobile) {
          setOpen(false);
        }
      };
  
      mobile.addEventListener("change", windowHandler);
      return () => {
        mobile.removeEventListener("change", windowHandler);
      };
    }, []);

    const handleChange = debounce(async (property, value) => {
      try {
        if (value && value._isAMomentObject) {
          const date_dt = new Date(value);
          const new_date = new Date(
            date_dt.getFullYear(),
            date_dt.getMonth(),
            date_dt.getDate(),
            10,
            56,
            0
          );
          row[property] = new_date;
        } else {
          row[property] = value;
        }
  
        const response = await Axios.put(
          `api/estate/liabilities/tax/${row.id}`,
          row
        );
  
        if (response && response.status === 200) {
          setLiabilities(response.data.data);
        }
      } catch (err) {
        console.error("Error updating property:", err);
      }
    }, 500);
 
    const positions = [
      "Husband",
      "Wife",
      "Joint",
      "Client",
      "Spouse",
      "Third Party",
      "Other"
    ]; 

    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <KeyboardArrowDownIcon style={{ color: blue }} />
              ) : (
                <KeyboardArrowRightIcon />
              )}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" className="font-weight-normal">
            {row.description ?? "N/A"} <Position position ={row.position}/>
          </TableCell>
            <TableCell align="left" className="font-weight-normal">
              ${row.value ?? ""} as of ({moment(row.value_date).format("L")})
            </TableCell>
            <TableCell align="left" className="font-weight-normal">
              ${row.other_liens ?? ""}
            </TableCell>
            <TableCell align="left" className="font-weight-normal">
              ${row.client_sp ?? ""}
            </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.spouse_sp ?? ""}
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
          <NumberFormat value={row.value - (row.client_sp + row.spouse_sp)?? ""} displayType={'text'} thousandSeparator={true} prefix={'$'} />
          </TableCell>
          <TableCell align="left"> 
            <ShowNoteComponent row={row} api ='api/estate/liabilities/tax' />
            <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
              <DeleteFederalLiability row={row} setLiabilities={setLiabilities} />
            </div>
            <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
              <FileUpload row={row} client_case_id={client_case_id} source={'federal-liabilities'}/>
            </div>
             <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <div className="shadow mb-3">
                  <List>
                    <Divider />
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Description :
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                         <TextInputField defaultValue={row.description} onChange={(e) => handleChange('description', e.target.value)} />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Over Payment: :
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                         <TextInputField defaultValue={row.value} onChange={(e) => handleChange('value', e.target.value)} />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Amount owed :
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                         <TextInputField defaultValue={row.other_liens} onChange={(e) => handleChange('other_liens', e.target.value)} />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Client SP:
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                         <TextInputField defaultValue={row.client_sp} onChange={(e) => handleChange('client_sp', e.target.value)} />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Spouse SP :
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                         <TextInputField defaultValue={row.spouse_sp} onChange={(e) => handleChange('spouse_sp', e.target.value)}/>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Liens/Debt
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      <NumberFormat value={row.value} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <ListItemText className="font-weight-normal">
                        Name/Control of:
                      </ListItemText>
                      <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                        <NativeSelect
                            className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                            inputProps={{
                              name: 'positions',
                            }} 
                            onChange={(e) => handleChange('position', e.target.value)} 
                            defaultValue={row.position}
                          >
                          {
                            positions.map((position, index) => {
                              return (
                                <option key={index} value={position}>{position}</option>
                              )
                            })
                          } 
                          </NativeSelect>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </div>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

function FederalLiabitlites(props) {
    const {handleOpen} = props;
    const encryptStorage = new EncryptStorage("secret-key");
    const decypt_data = encryptStorage.getItem("case_details");
    const client_case_id = decypt_data ? decypt_data.case.id : null;
    const [liabilities, setLiabilities] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetch_data = () => {
      setLoading(true);
      Axios.get("api/estate/liabilities/tax/" + client_case_id)
        .then((res) => {
          setLiabilities(res.data.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log("error", err);
          setLoading(false);
        });
    };
  
    useEffect(() => {
      fetch_data();
    }, []);
    return (
      <>
      <div className="d-flex px-9 align-items-center">
        <div className="ml-auto">
          <CreateFederalLiability
            setLiabilities={setLiabilities}
            client_case_id={client_case_id}
            handleOpen={handleOpen}
          />
        </div>
      </div>
        <div className="pb-10 pl-10 pr-10 pt-0">
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                    Description
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1" 
                  >
                    over payment
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Amount Owed
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Client SP
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Spouse SP
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Comm/Marital Debt
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {liabilities.map((row) => (
                  <FederalLiabitlitesRow
                    key={row.id}
                    row={row}
                    client_case_id={client_case_id}
                    setLiabilities={setLiabilities}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {loading && <Loading />}
        </div>
      </>
    );
  }

function OtherDebts(props) {
  const {handleOpen} = props;
  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}> 
        <FederalLiabitlites  handleOpen={handleOpen}/> 
      </div>
    </>
  )
}

export default OtherDebts